module.exports = __webpack_public_path__ + "static/media/logo-ORE-white-@2x.f9c1f916.png";